import { render, staticRenderFns } from "./EChangePasswordModal.vue?vue&type=template&id=06c79da3"
import script from "./EChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./EChangePasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports